function isEmptyValue(value: unknown): boolean {
  if (value === null || value === undefined) return true
  if (value === "") return true
  if (Array.isArray(value) && value.length === 0) return true
  if (typeof value === "object" && Object.keys(value as object).length === 0) return true
  return false
}

export function filterNonEmptyParams(args: Record<string, unknown>): Record<string, unknown> {
  return Object.fromEntries(Object.entries(args).filter(([, value]) => !isEmptyValue(value)))
}
